<template>
  <div class="flex items-center justify-center h-screen">
    <div class="text-center">
      <h1 class="text-2xl font-bold mb-4">Connexion en cours...</h1>
      <p>Veuillez ne pas rafraichir la page.</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import oidcAuth, { syncTokensWithCore } from '@/auth/oidcAuth'
import { useRouter } from 'vue-router'
import { useBoostCorePermissionStore } from '@/stores/useBoostCorePermissionStore'

const router = useRouter()

onMounted(async () => {
  try {
    // Process the Azure callback — saves OIDC user in localStorage. This
    // also fires `addUserLoaded`, whose handler ALSO calls syncTokensWithCore.
    const user = await oidcAuth.signinRedirectCallback()
    if (!user) throw new Error('Azure callback returned no user')

    // Establish the boostcore session via the SAME Web Lock + early-out path
    // as the addUserLoaded handler. The two callers serialize on the lock;
    // the second one hits the rawPingMe early-out instead of triggering a
    // duplicate POST /auth/user/login (which races on cookie/csrf and used
    // to bounce the user back to /auth/login on the first 365 click).
    await syncTokensWithCore(user)

    const boostCoreStore = useBoostCorePermissionStore()
    if (!boostCoreStore.user) {
      // syncTokensWithCore calls fetchMe internally; if user is still null
      // here, the session establishment failed.
      router.push('/auth/login')
      return
    }

    const redirectPath = sessionStorage.getItem('oidc_redirect') || '/'
    sessionStorage.removeItem('oidc_redirect')
    router.push(redirectPath)
  } catch (error) {
    console.error('Erreur pendant la redirection:', error)
    router.push('/auth/login')
  }
})
</script>
